/**
 * Funcionalitat compartir en xarxes socials
 */

function addCompartirMapa(){
	
	addHtmlInterficieCompartirMapa();
	
	var v_url = InstamapsUtils.Getters.getUrlMapa(window, Cookies, DOMINI, url('?id'));	
	
	if (v_url.indexOf("mapacolaboratiu=si")>-1) v_url=v_url.replace("&mapacolaboratiu=si","");
	
	
	//Compartir en xarxes socials
	if (InstamapsUtils.Validator.isRandomUser(Cookies.get('uid'))){
	
		jQuery(window).on('beforeunload',function(event){
			return 'Are you sure you want to leave?';
		});							
	
		jQuery('#socialShare').share({
			networks: ['email','facebook','googleplus','twitter','linkedin','pinterest'],
			theme: 'square'
		});
		
		jQuery('#socialShare .pop-social').off('click').on('click', function(event){
			event.preventDefault();
			jQuery('.modal').modal('hide');
			$('#dialgo_messages').modal('show');
			$('#dialgo_messages .modal-body').text(window.lang.translate(msg_noguarda));
		});
	}else{
		jQuery('#socialShare').share({
			networks: ['email','facebook','googleplus','twitter','linkedin','pinterest'],
			theme: 'square',
			urlToShare: v_url
		});
		
		jQuery('#socialShare .pop-social').on('click', function(event){
			publicarMapa(true);
		});
	}	
}

function addCompartirVisor(){
	var v_url = window.location.href;
	if(v_url.indexOf('localhost')!=-1){
		v_url = v_url.replace('localhost',DOMINI);
	}
	if (v_url.indexOf("mapacolaboratiu=si")>-1) v_url=v_url.replace("&mapacolaboratiu=si","");
	
	jQuery('#socialShare_visor').share({
		networks: ['email','facebook','googleplus','twitter','linkedin','pinterest'],
		theme: 'square',
		urlToShare: v
	});

	jQuery('.share-square a').attr('target','_blank');
	
}

function posaClassActiu(_element){
	var cl = jQuery(_element).attr('class');
	if (cl.indexOf('grisfort') != -1) {
		jQuery(_element).removeClass('grisfort');
		jQuery(_element).addClass('greenfort');
	} else {
		jQuery(_element).removeClass('greenfort');
		jQuery(_element).addClass('grisfort');
	}
}

function addHtmlInterficieCompartirMapa(){
	jQuery("#funcio_compartir").append(
			'<div id="socialShare" class="div_gr5_social">'+
				'<h5 lang="ca">Compartir</h5>'+
			'</div>'
	);
}